import React, { Component } from "react"
import { Container, Row, Col } from 'reactstrap'
import PaymentPlanListHeader from "./PaymentPlanListHeader"
import PaymentPlanList from "./PaymentPlanList"
import ListingTabs from "../../Material/ListingTabs"
import ReportsPanel from "../../Reports/ReportsPanel"
import { buildPresets } from "../../Filters/presetFilters"
import { ROUTES } from "../../Layout/routes"
import { withPathTab } from "../../Functions/usePathTab"

// Editable, visible default: the list opens showing active plans; the user can
// flip the status or drop the preset entirely from the popover/chips.
// "1" is the raw model value -- NOT the graphene enum name "A_1".
const ACTIVE_STATUS_PRESET = [
    { fieldName: "status", filterType: "equal", filterValues: "1", editable: true, visible: true },
]

// Stable identity, built once: setPresets only ever touches state.presets, so
// this is untouched by user edits and is what Reset returns to.
const DEFAULT_PRESETS = buildPresets(ACTIVE_STATUS_PRESET)

export const PAYMENT_PLAN_LISTING_TABS = [
    { id: "all", name: "Payment Plans" },
    { id: "reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true },
]

class PaymentPlanListContainer
    extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterValues: {
                orderBy: ["-id"]
            },
            presets: DEFAULT_PRESETS,
            refetchPaymentPlans: false,
        }
    }

    setPresets = (presets) => this.setState({ presets })

    updateOrder = (string) => {
        let order = this.state.filterValues.orderBy ? [...this.state.filterValues.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState((prevState) => ({ filterValues: { ...prevState.filterValues, orderBy: order } }))
    };

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <ListingTabs
                    tabs={PAYMENT_PLAN_LISTING_TABS}
                    activeTab={this.props.activeTabId}
                    onChange={this.props.changeTab}
                />
                {this.props.activeTabId !== "reports" && <PaymentPlanListHeader
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={DEFAULT_PRESETS}
                    currentUser={this.props.currentUser}
                    location={this.props.location}
                    history={this.props.history}
                />}
                <Row>
                    <Col>
                        {this.props.activeTabId === "reports" ?
                            <ReportsPanel reportId="payment_plans" />
                            :
                            <PaymentPlanList
                                key={String(this.state.refetchPaymentPlans)}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                updateOrder={this.updateOrder}
                                currentUser={this.props.currentUser}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                presets={this.state.presets}
                            />}

                    </Col>
                </Row>
            </Container>

        )
    }
}

export default withPathTab(ROUTES.paymentPlans)(PaymentPlanListContainer)
